import PubSub from "underpub-js";

var NavigationBarSubItem = function(options) {

	this.options = {
		$el: false,
		baseClass: 'atom-NavigationBarSubItem',
	};

	$.extend(true, this.options, options);

};

NavigationBarSubItem.prototype.init = function() {

	var self = this;

};

export default NavigationBarSubItem;
